import { Link, useLocation } from "react-router-dom";

/**
 * Footer used on every page. Markup mirrors the original `.site-footer`
 * exactly so all `.site-footer *` rules in maltora.css apply unchanged.
 */
export default function Footer() {
  const { pathname, hash } = useLocation();
  const handleAboutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (pathname === "/" && hash === "#about") {
      e.preventDefault();
      const el = document.querySelector("#about");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <nav className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/pricing" state={{ fromApp: true }}>
            Pricing
          </Link>
          <Link to="/blog" state={{ fromApp: true }}>
            Blog
          </Link>
          <Link to="/#about" onClick={handleAboutClick}>
            About Us
          </Link>
          <Link to="/trust" state={{ fromApp: true }}>
            Trust &amp; Security
          </Link>
        </nav>
        <div className="footer-bottom">
          <span>
            &copy; 2026 Maltora. All rights reserved. &middot;{" "}
            <Link
              to="/terms"
              state={{ fromApp: true }}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              Terms
            </Link>{" "}
            &middot;{" "}
            <Link
              to="/privacy"
              state={{ fromApp: true }}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              Privacy
            </Link>
          </span>
          <span>
            <a
              href="mailto:support@maltora.app"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              support@maltora.app
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
